import {
  createClient,
  joinRoom,
  leaveRoom,
  closeAudio,
  openAudio,
  closeVideo,
  openVideo
} from "./tencent";
import {isEmpty} from "../utils";

export const tencentmixin = {
  props: {
    roomId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pusher: {},
      players: [],
      videos: [],
      interVal: null,
      mainUserId: '',
      ownId: '',
      usersPlays: [],
      tencentSign:null,
    }
  },
  created() {
    // this.getTencentSign()
    bus.$on('onCreateLocalStrem',this.createlocalMedia)
    bus.$on('onReciveRemoteStrem',this.reciveRemoteMedia)


    bus.$on('onGetAccessToken', this.tee3enterRoom);
    bus.$on('initSuccess', this.tee3initSuccess);
    bus.$on('joinSuccess', this.tee3joinSuccess);
    bus.$on('onUserLeaveNotify', (opt, reason, user) => {
      this.deletePlayer(user);
    });
    bus.$on('onPublishCameraNotify', (videos) => {
      this.subscrible('video', videos);
    });
    bus.$on('onPublishMicrophoneNotify', (audios) => {
      this.subscrible('audio', audios);
    })
    bus.$on('onSubscribleCameraResult', (stream, userId, userName, cameraId) => {
      this.updatePlayer({
        id: userId,
        name: userName,
        videoStream: stream
      })
      this.handlerRemoteMedia({type: 'video', stream, userId, userName, cameraId});
    });
    bus.$on('onSubscribleMicrophoneResult', (stream, userId, userName) => {
      this.updatePlayer({
        id: userId,
        name: userName,
        audioStream: stream
      })
      this.handlerRemoteMedia({type: 'audio', stream, userId, userName});
    });
    bus.$on('onUserJoinNotify', this.joinUserNotify);
    bus.$on('onUserLeaveNotify', this.userLeaveNotify);
  },
  beforeDestroy() {
    bus.$off('onCreateLocalStrem',this.createlocalMedia)
    bus.$off('onReciveRemoteStrem',this.reciveRemoteMedia)

    bus.$off('onGetAccessToken', this.tee3enterRoom);
    bus.$off('initSuccess', this.tee3initSuccess);
    bus.$off('joinSuccess', this.tee3joinSuccess);
    bus.$off('onUserJoinNotify', this.joinUserNotify);
    bus.$off('onUserLeaveNotify', this.userLeaveNotify);
    bus.$off('onSubscribleMicrophoneResult');
    bus.$off('onSubscribleCameraResult');
  },
  methods: {
    async getTencentSign(userId){
      const {obj} = await this.$http('smarthos.video.tencent.sign',{})
      this.tencentSign = obj
      createClient(userId,this.tencentSign)
    },
    joinRoom(roomId,userId){
      return joinRoom(roomId,userId)
    },
    leaveRoom() {
      this.$emit('hangUp')
      return leaveRoom();
    },
    createlocalMedia(stream){
      this.$refs.local.srcObject = stream;
    },
    reciveRemoteMedia(stream){
      this.$refs.remoteVideo.srcObject = stream;
    },



    getRoom() {
      const room = tee3getRoom();
      return isEmpty(room)
    },
    openScreenAndPub(local) {
      const room = tee3getRoom();
      if (isEmpty(room)) return this.$message.error('还未进入房间');
      return tee3OpenScreenAndPub(local);//分享桌面
    },
    gettee3videoStatus() {
      return tee3videoStatus();
    },
    tee3OpenVideo(local) {
      openCameraAndPubVideo(local);
    },
    tee3CloseVideo() {
      tee3closeCameraAndPubVideo()
    },
    gettee3microphoneStatus() {
      return gettee3MicrophoneStatus();
    },
    tee3OpenMicrophone() {
      return tee3openMicrophone();
    },
    tee3CloseMicrophone() {
      tee3closeMicrophone();
    },
    tee3enterRoom(accessToken) {
      if (!accessToken) {
        tee3getAccessToken();
      } else {
        tee3init(accessToken);
      }
    },
    tee3leaveRoom() {
      const room = tee3getRoom();
      if (isEmpty(room)) return this.$message.error('还未进入房间');
      return tee3LeaveRoom();
    },
    tee3initSuccess() {
      const {docInfo} = this;
      this.roomId && tee3join(this.roomId, docInfo.id, docInfo.id);
    },
    tee3joinSuccess() {
      const room = tee3getRoom();
      const users = room.getParticipants();
      Log('pubVideos', room.pubVideos);
      this.subscrible('video', room.pubVideos);
      this.handlerUsers(users);
    },
    subscrible(type, arr) {
      const room = tee3getRoom();
      const selfUser = room.selfUser;
      const subIds = type === 'video' ? selfUser.subVideoIds : selfUser.subAudioIds;
      Log('subIds', subIds);
      arr.forEach(item => {
        if (subIds.length > 0) {
          if (subIds.findIndex(id => item.id === id) < 0) {
            item.subscrible();
          }
        } else {
          item.subscrible();
        }
      });
    },
    handlerUsers(users) {
      const room = tee3getRoom();
      const selfUser = room.selfUser;
      users.forEach(user => {
        if (user.id === selfUser.id) {
          this.updatePusher('id', user.id);
          this.updatePusher('name', user.name);
          this.publish(user);
        }
        this.addPlayer(user);
      });
    },
    publish(user) {
      const room = tee3getRoom();
      const selfUser = room.selfUser;
      const localEl = this.$refs.local;
      Log('publish videos', user.videos);
      user.videos.forEach((v, index) => {
        let localVideo, localVideos;
        if (localEl.tagName === "DIV") {
          localVideos = localEl.querySelectorAll('video');
          localVideo = localVideos[index];
        } else localVideo = localEl;
        const video = selfUser.getVideo(v.id);
        video.setResolutionWH(1080, 720, ResolutionSetType.ideal);
        video.preview(localVideo).then(function () {
          video.publish().otherwise((error) => {
            console.error('publish error', error)
          });
        }).otherwise((error) => {
          console.error('preview error', error)
        });
      });

      if (user.audio && user.audio.id) {
        let audio = selfUser.getAudio(user.audio.id);
        audio.openMicrophone().otherwise((error) => {
          console.error('openMicrophone error', error)
        });
      }
    },
    updatePusher(key, value) {
      this.$set(this.pusher, key, value);
    },
    addPlayer(user) {
      const selfUser = tee3getSelfUser();
      const index = this.players.findIndex(r => r.id === user.id);
      if (index < 0) {
        this.players.push({
          id: user.id,
          name: user.name,
          self: selfUser.id === user.id
        });
      } else {
        this.updatePlayer(user);
      }
    },
    updatePlayer(user) {
      const index = this.players.findIndex(r => r.id === user.id);
      if (index >= 0) {
        let player = this.players[index];
        player = {...player, ...user};
        this.players.splice(index, 1, player);
        //this.handlerMedia(player);
      } else {
        this.addPlayer(user);
      }
    },
    updateOrAddVideo(video) {
      //this.handlerRemoteMedia(video);
      const name = video.name || video.cameraId || video.screenId || "";
      let idx = this.videos.findIndex(r => r.userId === video.userId && r.type === video.type && r.name === name);
      if (idx >= 0) {//更新
        this.videos.splice(idx, 1, {...this.videos[idx], ...video, name});
      } else {//增加
        this.videos.push({...video, name});
      }
    },
    findVideo(id, type) {
      let idx = this.videos.findIndex(r => r.userId === id && r.type === type);
      if (idx >= 0) {
        return this.videos[idx]
      }
    },
    deletePlayer(user) {
      const index = this.players.findIndex(r => r.id === user.id);
      if (index >= 0) {
        this.players.splice(index, 1);
      }
    },
    /**
     * 轮询查看屏幕共享是否关闭
     */
    checkScreenOutSelfUser(local) {
      const that = this;
      this.interVal = setInterval(() => {
        if (that.getScreenState() == '1') {
          that.previewVideo(local);
        }
      }, 5000)
    },

    getScreenState() {
      let selfUser = tee3getSelfUser();
      return selfUser.screen.status
    },

    previewVideo(local) {
      let selfUser = tee3getSelfUser();
      let videos = selfUser.videos;
      videos.forEach((v) => {
        const video = selfUser.getVideo(v.id);
        // video.unpreview();
        video.preview(local).otherwise((error) => {
          console.error('publish error', error)
        });
      })
      clearInterval(this.interVal);
    },

    //获取参会者列表(包括本人)
    getPlayers() {
      let selfUser = tee3getSelfUser();
      let users = tee3getPlayers();
      console.log('参会者')
      console.log(users)
      this.usersPlays = users;
      this.ownId = selfUser.id;//当前user对象
      this.mainUserId = users[users.length - 1].id;
    },
    //加入参会者回调事件（不包括本人）
    joinUserNotify(user) {
      this.getPlayers();//获取参会者
      // let selfUser = tee3getSelfUser();
      // this.ownId = selfUser.id;//当前user对象
      // console.log('参会者')
      // console.log(user)
      // for(let o in user){
      //   //alert(this.mainUserId);
      //   if(this.mainUserId == ''){
      //     this.mainUserId = user[o].id;
      //   }
      // }
      //this.getPlayers();//获取参会者
      // let userId = user.id;//参加会议的人员对象
      // let selfUser = tee3getSelfUser();
      // this.ownId = selfUser.id;//当前user对象
      // if(this.mainUserId == '' && userId != this.ownId){
      //   this.mainUserId = userId;//主视频id
      // }
    },
    userLeaveNotify(opt, reason, user) {
      this.getPlayers();//获取参会者
      console.log('离开会议的参数')
      console.log(opt)
      console.log(reason)
      console.log(user)
    },
    getRoomId() {
      let room = tee3getRoom();
      return room.id;
    }
  }
}
